import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaRecuperacao = (): TabelaColuna => ({
  Chave: 'recuperacao',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Recuperação</div>
})
